import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Computer from "@material-ui/icons/Computer";
import Event from "@material-ui/icons/Event";
import CastForEducation from "@material-ui/icons/CastForEducation";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import InfoArea from "components/InfoArea/InfoArea.js";

import farjadLogo from "assets/img/farjad-logo.png";
import honorTechnical from "assets/img/farjad/honor-technical.jpg";
import honorPark from "assets/img/farjad/honor-park.webp";
import honorNsr from "assets/img/farjad/honor-nsr.png";
import honorSharif from "assets/img/farjad/honor-sharif.png";
import solutionTpan from "assets/img/farjad/solution-tpan.jpg";
import solutionBeagile from "assets/img/farjad/solution-beagile.jpg";
import solutionSharifcamp from "assets/img/farjad/solution-sharifcamp.jpg";
import solutionItnext from "assets/img/farjad/solution-itnext.jpg";
import solutionSpaghetti from "assets/img/farjad/solution-spaghetti.jpg";
import solutionRobocup from "assets/img/farjad/solution-robocup.png";
import solutionHorbit from "assets/img/farjad/solution-horbit.png";

import styles from "assets/jss/material-kit-react/views/topdev.js";
import Axios from "axios";
import Config from "../../../config.js"
import swal from 'sweetalert'


const useStyles = makeStyles(styles);

export default function ACCNMainPage(props) {
    const classes = useStyles();
    const [challenges, setChallenges] = useState(null);

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
    var next = (register, challengeId) => {
        props.history.push("/ACCN/Challenges/" + challengeId);
    }
    var start = (challengeId, index) => {
        if (!challenges[index].active) {
            return swal("تا شروع مسابقه صبر کنید.")
        }
        if (localStorage.getItem('token')) {
            Axios.post(Config.api + "Challenge/RegisterInChallenge", {
                challengeId: challengeId
            },
                {
                    headers: {
                        apikey: Config.apikey,
                        Authorization: "Bearer " + localStorage.getItem('token')

                    }
                }).then(async (result) => {
                    next(1, challengeId);
                }).catch((err) => {
                    console.log(err)
                    if (err && err.response && err.response.status && err.response.status === 401) {
                        swal("برای شروع مسابقه، باید وارد شوید.").then(() => {
                            localStorage.removeItem('token');
                            props.history.push("/SignIn");
                        })
                    }
                    else if (err && err.response && err.response.status && err.response.status === 422)
                        swal("اطلاعات ارسالی نادرست است.");
                    else if (err && err.response && err.response.status && err.response.status === 409) {
                        next(0, challengeId);
                    }
                    else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
                        swal(err.response.data.message.pr);
                    else swal("خطایی رخ داده است.")
                })
        } else {
            swal("برای شروع مسابقه، باید وارد شوید.").then(() => {
                localStorage.removeItem('token');
                props.history.push("/SignIn");
            })
        }
    }
    useEffect(() => {
        Axios.post(Config.api + "Challenge/GetChallenges", {
            "filter": ""
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                console.log(result)
                setChallenges(result.data.data);
            }).catch((err) => {
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.status && err.response.status === 409) {
                    next(0);
                }
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
                    swal(err.response.data.message.pr);
                else swal("خطایی رخ داده است.")
            })
    }, []);
    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax small filter image={require("assets/img/bg21.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>
                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={"http://sharifcamp.ir/assets/images/azad.jpg"} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>المپیک برنامه نویسی دانشگاه آزاد اسلامی</h3>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer alignItems="stretch" className={classes.box}>
                                    <GridItem xs={12} sm={12} md={4} className={classes.challengeCol}>
                                        <Card className={classes.root + " " + classes.card} variant="outlined">
                                            <CardActionArea className={classes.cardMain}>
                                                <CardMedia
                                                    className={classes.media}
                                                    image={"http://sharifcamp.ir/assets/images/kooh.png"}
                                                    title="UstmbJam"
                                                />
                                                <CardContent>
                                                    <Typography gutterBottom variant="h6" component="h3">
                                                       فاتحان قله های علم
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary" component="p">
                                                       اولین دوره مسابقه برنامه نویسی، شهریور ماه ۱۴۰۵
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                            <CardActions className={classes.challengeActions}>
                                                <Button
                                                    onClick={() => start("6a88685b4ba58bf60d00de61", 9)}
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    fullWidth
                                                    disableElevation
                                                    className={classes.challengeStartBtn}
                                                >
                                                    ورود به مسابقه
                                                </Button>
                                                <p className={classes.challengeStartHint}>
                                                    برای شروع و شرکت در مسابقه، روی این دکمه کلیک کنید
                                                </p>
                                            </CardActions>
                                        </Card>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8} className={classes.partnerAside}>
                                        <div className={classes.partnerAsideInner}>
                                            <div className={classes.partnerLogo}>
                                                <img src={farjadLogo} alt="فرجاد سامانه شریف" />
                                            </div>
                                            <h2 className={classes.h2Main}>فرجاد سامانه شریف</h2>
                                            <p className={classes.sub}>طراحی و راه‌اندازی زیرساخت فنی این رویداد</p>
                                            <div className={classes.partnerDescription}>
                                                <p>
                                                    شرکت فرجاد سامانه شریف با بیش از یک دهه تجربه در حوزه فناوری اطلاعات،
                                                    این بستر رقابتی را طراحی و راه‌اندازی کرده است. فعالیت این مجموعه در سه محور
                                                    سامانه‌های نرم‌افزاری، رویدادهای تخصصی و آموزش‌های نوین متمرکز است.
                                                </p>
                                            </div>
                                            <div className={classes.partnerActions}>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    href="https://farjadsamaneh.ir/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    disableElevation
                                                >
                                                    مشاهده وب‌سایت فرجاد سامانه شریف
                                                </Button>
                                            </div>
                                        </div>
                                    </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.partnerSection}>
                                    <div className={classes.partnerInfoWrap}>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={4} className={classes.partnerInfoItem}>
                                                <InfoArea
                                                    title="سامانه‌های نرم‌افزاری"
                                                    description="طراحی و توسعه راهکارهای نرم‌افزاری مانند تور مجازی ترنج، سامانه‌های سازمانی و بسترهای تخصصی فناوری اطلاعات."
                                                    icon={Computer}
                                                    iconColor="primary"
                                                    vertical
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={4} className={classes.partnerInfoItem}>
                                                <InfoArea
                                                    title="رویدادهای تخصصی"
                                                    description="برگزاری مسابقات برنامه‌نویسی، رویدادهای تجربه‌محور و همایش‌های فناوری در سطح دانشگاهی و ملی."
                                                    icon={Event}
                                                    iconColor="info"
                                                    vertical
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={4} className={classes.partnerInfoItem}>
                                                <InfoArea
                                                    title="کلاس‌ها و آموزش"
                                                    description="دوره‌ها و کارگاه‌های تخصصی از برنامه‌نویسی و اسکرام تا هوش مصنوعی، با گواهینامه قابل استعلام."
                                                    icon={CastForEducation}
                                                    iconColor="success"
                                                    vertical
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </div>

                                    <h3 className={classes.partnerBlockTitle}>سامانه‌ها و راهکارها</h3>
                                    <p className={classes.partnerBlockSub}>محصولات و پروژه‌های شاخص فرجاد سامانه شریف</p>
                                    <GridContainer>
                                        <GridItem xs={12} sm={6} md={4} className={classes.partnerSolutionItem}>
                                            <a className={classes.partnerSolutionLink} href="https://horbit.farjadsamaneh.ir/" target="_blank" rel="noopener noreferrer">
                                                <img src={solutionHorbit} alt="Horbit" className={classes.partnerSolutionImgDark} />
                                                <h5>Horbit</h5>
                                                <p>سرور مجازی ابری برای کسب‌وکارها و توسعه‌دهندگان؛ راه‌اندازی سریع لینوکس و ویندوز با پشتیبانی فارسی</p>
                                            </a>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={4} className={classes.partnerSolutionItem}>
                                            <a className={classes.partnerSolutionLink} href="https://tpan.ir/" target="_blank" rel="noopener noreferrer">
                                                <img src={solutionTpan} alt="تور مجازی ترنج" className={classes.partnerSolutionImg} />
                                                <h5>تور مجازی ترنج</h5>
                                                <p>سامانه ساخت تور مجازی ۳۶۰ درجه با پنل مدیریت برای کسب‌وکارها، مراکز آموزشی و نمایشگاه‌ها</p>
                                            </a>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={4} className={classes.partnerSolutionItem}>
                                            <a className={classes.partnerSolutionLink} href="https://itnext.farjadsamaneh.ir/" target="_blank" rel="noopener noreferrer">
                                                <img src={solutionItnext} alt="ITNext" className={classes.partnerSolutionImg} />
                                                <h5>ITNext</h5>
                                                <p>رویداد ملی تجربه‌محور فناوری اطلاعات؛ گردهمایی متخصصان، سخنرانان و استارتاپ‌ها برای تبادل دانش و شبکه‌سازی</p>
                                            </a>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={4} className={classes.partnerSolutionItem}>
                                            <a className={classes.partnerSolutionLink} href="https://beagile.ir/" target="_blank" rel="noopener noreferrer">
                                                <img src={solutionBeagile} alt="چابک باش" className={classes.partnerSolutionImg} />
                                                <h5>چابک باش</h5>
                                                <p>نرم‌افزار ارائه بازخورد به تیم فنی با رویکرد چابک برای بهبود عملکرد و بهره‌وری سازمان</p>
                                            </a>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={4} className={classes.partnerSolutionItem}>
                                            <a className={classes.partnerSolutionLink} href="https://sharifcamp.ir/" target="_blank" rel="noopener noreferrer">
                                                <img src={solutionSharifcamp} alt="کمپ آموزشی شریف" className={classes.partnerSolutionImg} />
                                                <h5>کمپ آموزشی شریف</h5>
                                                <p>برگزاری دوره‌ها، کارگاه‌ها و رویدادهای مهارتی فناوری اطلاعات با گواهینامه معتبر</p>
                                            </a>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={4} className={classes.partnerSolutionItem}>
                                            <a className={classes.partnerSolutionLink} href="/SOPC">
                                                <img src={solutionSpaghetti} alt="Spaghetti" className={classes.partnerSolutionImg} />
                                                <h5>Spaghetti</h5>
                                                <p>مسابقه و چالش کدنویسی مبهم برای تقویت تفکر الگوریتمی، کار تیمی و درک عمیق از زبان‌های برنامه‌نویسی</p>
                                            </a>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={4} className={classes.partnerSolutionItem}>
                                            <a className={classes.partnerSolutionLink} href="https://soccer.farjadsamaneh.ir/" target="_blank" rel="noopener noreferrer">
                                                <img src={solutionRobocup} alt="Robocup Soccer Simulation" className={classes.partnerSolutionImg} />
                                                <h5>Robocup Soccer Simulation</h5>
                                                <p>سامانه شبیه‌سازی رایانه‌ای فوتبال برای برگزاری لیگ‌ها و مسابقات مجازی با موتور اختصاصی بازی</p>
                                            </a>
                                        </GridItem>
                                    </GridContainer>

                                    <h3 className={classes.partnerBlockTitle}>گواهینامه‌ها و مدارک</h3>
                                    <p className={classes.partnerBlockSub}>مجوزها، عضویت‌ها و همکاری‌های رسمی سازمانی</p>
                                    <GridContainer>
                                        <GridItem xs={6} sm={6} md={3} className={classes.partnerHonorItem}>
                                            <div className={classes.partnerHonorCard}>
                                                <img src={honorTechnical} alt="فنی و حرفه‌ای" className={classes.partnerHonorImg} />
                                                <p className={classes.partnerHonorTitle}>مجوز رسمی از سازمان آموزش فنی و حرفه‌ای کشور</p>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={6} sm={6} md={3} className={classes.partnerHonorItem}>
                                            <div className={classes.partnerHonorCard}>
                                                <img src={honorPark} alt="پارک علم و فناوری" className={classes.partnerHonorImg} />
                                                <p className={classes.partnerHonorTitle}>مستقر در پارک علم و فناوری استان مازندران</p>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={6} sm={6} md={3} className={classes.partnerHonorItem}>
                                            <div className={classes.partnerHonorCard}>
                                                <img src={honorNsr} alt="نظام صنفی رایانه‌ای" className={classes.partnerHonorImg} />
                                                <p className={classes.partnerHonorTitle}>عضو سازمان نظام صنفی رایانه‌ای استان مازندران</p>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={6} sm={6} md={3} className={classes.partnerHonorItem}>
                                            <div className={classes.partnerHonorCard}>
                                                <img src={honorSharif} alt="پژوهشکده شریف" className={classes.partnerHonorImg} />
                                                <p className={classes.partnerHonorTitle}>کارگزار رسمی پژوهشکده فناوری اطلاعات و ارتباطات پیشرفته دانشگاه صنعتی شریف</p>
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
